import React from 'react';
import { Modal, Typography } from '@ann/web-components';
import { ModalHeader } from './ModalBase.styled';

const ModalBase = ({
                       title,
                       description,
                       buttonTitle,
                       disabled=false,
                       size="medium",
                       modalWidth,
                       children,
                       isOpen,
                       onClose,
                       onClick }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} width={modalWidth} size={size}>
            <Modal.Header/>
            <ModalHeader>
                <Modal.Header.Title>
                    <Typography category="title" size="medium" weight="bold">
                        {title}
                    </Typography>
                </Modal.Header.Title>
                <Modal.Header.Description>
                    <Typography category="body" size="medium" weight="regular">
                        {description}
                    </Typography>
                </Modal.Header.Description>
            </ModalHeader>

            {children && (
                <Modal.Body>
                    {children}
                </Modal.Body>
            )}

            <Modal.Actions align="center">
                <Modal.Button
                    label="Cancel"
                    onClick={() => onClose()}
                    type="secondary"
                />
                <Modal.Button
                    label={buttonTitle || 'Save'}
                    onClick={() => onClick()}
                    disabled={disabled}
                />
            </Modal.Actions>
        </Modal>
    )
}

export default ModalBase